import { TRootState }    from 'Redux/Reducers';
import { arrayContains } from 'Utils';
import Actions           from 'Redux/Actions';

export const isEventEmployeesLoading = (state: TRootState): boolean =>
  arrayContains(state.event.openRequests, [
    Actions.findEventEmployeesRequest.type,
    Actions.assignEventEmployeesRequest.type,
  ]);
